/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../..";
import useOrderItems from "./useOrderItems";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { PriceSummary } from "../PriceSummary";

export const OrderItems = ({
  orderDetails,
  isViaTnx = true,
  type = "SOLD",
}) => {
  const { orderItems, setOrderItems, instance } = useOrderItems({
    orderDetails,
    type,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div>
        {isViaTnx ? <h5>Order Items</h5> : null}
        {orderDetails?.has_returned_items && isViaTnx ? (
          <div className={`mt-3 ${globalStyles.rowNavigations}`}>
            <a
              className={`${globalStyles.rowNavigations__item} ${
                orderItems === "SOLD" ? globalStyles.active : ""
              }`}
              onClick={() => setOrderItems("SOLD")}
            >
              Sold Items
            </a>

            <a
              className={`${globalStyles.rowNavigations__item} ${
                orderItems === "RETURNED" ? globalStyles.active : ""
              }`}
              onClick={() => setOrderItems("RETURNED")}
            >
              Returned Items
            </a>
          </div>
        ) : null}
        <div className={styles.orderItem}>
          <secondaryComponents.TableHelper
            getTableProps={getTableProps}
            getTableBodyProps={getTableBodyProps}
            headerGroups={headerGroups}
            rows={rows}
            prepareRow={prepareRow}
            minHeight={0}
          >
            <div className="text-center mt-5 mb-5">
              <h4 className="font-weight-semibold text-center mt-4">
                No Data Available
              </h4>
            </div>
          </secondaryComponents.TableHelper>
        </div>
      </div>

      <PriceSummary orderDetails={orderDetails} summaryType={orderItems} />
    </>
  );
};
